export default __webpack_public_path__ + "static/Santander-8e6bda28f6152f1837146e79b301df46.png";